// extracted by mini-css-extract-plugin
export default {"card":"Statistic_card__+ONS6"};